// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world
import wixData from 'wix-data';


$w.onReady(function () {

	var idMethod=""
	$w('#text135').hide()
	var idStatus=idValidation()

wixData.get("ramzorAnswers", "idMethod" )
  .then( (item) => {
	  if(item.method==="phone"){
idMethod="phone" 
$w('#text134').show()
$w('#input1').show()
$w('#text127').hide()
$w('#dropdown2').hide()
	  } else{
idMethod="dropdown"
$w('#text134').hide()
$w('#input1').hide()
$w('#text127').show()
$w('#dropdown2').show()
	  }
  })

	$w("#dropdown2").onChange((event)=>{hideWarning()})
	$w("#input1").onChange((event)=>{
		if (($w('#input1').value).length<5){
		idValidation()}})

$w("#text120").hide()
$w("#text121").hide()
$w("#text123").hide()

hideWarning()
function hideWarning(){
$w("#text128").hide()
$w("#text129").hide()
$w("#text130").hide()
$w("#text131").hide()
$w("#text132").hide()
$w("#text133").hide()
}

$w('#button17').onClick((event)=>{createPlayer()})

var startTime=0

setInterval (getStartTime, 10000)
setInterval (getStartTime, 20000)
setInterval (getStartTime, 60000)


function getStartTime(){
wixData.get ("ramzorAnswers", "StartTime")
.then((number) => {startTime=number.startTime})
}


setInterval (timer, 1000)
function timer(){
	
	let a= new Date().getTime()
		let timePassed= a-startTime
				if (timePassed>0 && timePassed<720000 ) {
			$w("#text120").show()
			$w("#text121").show()
			$w("#text123").show()
		}
		if (timePassed > 600000) {
			$w("#text120").text="Time is up..."
			$w("#text121").text="Time is up..."
			$w("#text123").text="Time is up..."
			return
		}
	let minutes = Math.floor(timePassed/60000)
	let seconds = Math.floor(timePassed/1000-minutes*60)
	$w("#text120").text= minutes+ " : " + ("0" + seconds).slice(-2)
	$w("#text121").text= minutes+ " : " + ("0" + seconds).slice(-2)
	$w("#text123").text= minutes+ " : " + ("0" + seconds).slice(-2)
}


for (let i=1; i<19; i++)  {
$w("#b"+i+"").onClick((event) =>{saveAnswer(i)})}

function saveAnswer (qnumber){
	
if (new Date().getTime()-startTime > 600000) {return}
idStatus=idValidation()
if (idStatus===false){return}


if ($w("#q"+qnumber+"").selectedIndex===undefined){
$w("#b"+qnumber+"").label = "בחרו תשובה";
return}
	
if (idStatus===true) {
let teamID=""
	if (idMethod==="dropdown"){teamID =$w("#dropdown2").value+""} else {teamID=$w('#input1').value}
	
	wixData.get("ramzorAnswers", teamID )
  .then( (item) => {
  let a=("t"+qnumber+"")
  let time=("time"+qnumber+"")
    item[a] = $w("#q"+qnumber).value; 
	item[time]=new Date().getTime()
	item["time0"]=startTime
    wixData.save("ramzorAnswers", item);
  } )
  .catch( (err) => {
    let errorMsg = err;
  } );

	setTimeout (function () {$w("#b"+qnumber+"").label = "Saved"},0);
	setTimeout (function () {$w("#b"+qnumber+"").hide("fade")},0);
	//setTimeout (function () {$w("#b"+qnumber+"").label = "עדכן"},3000);
//	setTimeout (function () {$w("#b"+qnumber+"").show()},5000);
	return
	}


}
	
function idValidation (){
	if(idMethod==="dropdown"){
		if ($w("#dropdown2").selectedIndex===undefined){ 
	$w("#dropdown2").style.borderColor="red"
	$w("#dropdown2").style.borderWidth="2px"
	$w("#text128").show()
	$w("#text129").show()
	$w("#text130").show()
	$w("#text131").show()
	$w("#text132").show()
	$w("#text133").show()
	return false
	} else {
		$w("#dropdown2").style.borderColor="blue"
		$w("#dropdown2").style.borderWidth="1px"
		$w("#text128").hide()
		$w("#text129").hide()
		$w("#text130").hide()
		$w("#text131").hide()
		$w("#text132").hide()
		$w("#text133").hide()
		return true
	}

	} else {
		if (($w('#input1').value).length<5){ 
			$w("#input1").style.borderColor="red"
			$w("#input1").style.borderWidth="2px"
			$w('#text135').show()
			$w("#text128").show()
			$w("#text129").show()
			$w("#text130").show()
			$w("#text131").show()
			$w("#text132").show()
			$w("#text133").show()
			$w('#button17').label="שליחה"
			return false} else{
			$w("#input1").style.borderColor="blue"
			$w("#input1").style.borderWidth="1px"
			$w("#text128").hide()
			$w("#text129").hide()
			$w("#text130").hide()
			$w("#text131").hide()
			$w("#text132").hide()
			$w("#text133").hide()
			$w('#text135').hide()
			return true}

	}
}	

function createPlayer(){
	idStatus=idValidation()
	if (idStatus===true){
	let player={
		"_id": $w('#input1').value+""
	}
	wixData.insert ("ramzorAnswers", player)
	$w('#button17').label="נקלט"
} else{ idValidation()

}
}
	
})



















